import Text from "components/Text";
import styled from "styled-components";
import theme from "theme";
import { colors } from "theme/colors";

export const Link = styled(Text)<{ isActive: boolean }>`
    color: ${({ isActive }) =>
        isActive ? colors.purple.primary : colors.grey.dark};
    border-bottom: ${({ isActive }) =>
        isActive && `2px solid ${colors.purple.primary}`};

    &:hover {
        color: ${colors.purple.primary};
        border-bottom: 2px solid ${colors.purple.primary};
    }
    margin: 1rem 0;
    padding-bottom: 6px;
    cursor: pointer;
`;

export const PhotoGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    margin-top: 5px;
`;

export const Photo = styled.img`
    width: 200px;
    height: 200px;
    border-radius: 16px;
    object-fit: cover;

    @media (${theme.breakpoints.mobileL}) {
        width: 100px;
        height: 100px;
        border: 1px solid #d3d3d3;
    }
`;
